// removed by extract-text-webpack-plugin
module.exports = {"Content":"Layout__Content__3KSp3"};


//////////////////
// WEBPACK FOOTER
// ./src/hoc/Layout/Layout.css
// module id = 29
// module chunks = 0